import { render, staticRenderFns } from "./AmendmentFiles.vue?vue&type=template&id=54bb8846&scoped=true&"
import script from "./AmendmentFiles.vue?vue&type=script&lang=js&"
export * from "./AmendmentFiles.vue?vue&type=script&lang=js&"
import style0 from "./AmendmentFiles.vue?vue&type=style&index=0&id=54bb8846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb8846",
  null
  
)

export default component.exports